module.exports = __webpack_public_path__ + "static/media/Audio Cassette.41cdf90e.png";